import { useMyPortfolioCapsulesConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { MyPortfolioCapsulesWidgetConfigState } from 'widgets/myPortfolioCapsules/store/config/MyPortfolioCapsulesWidgetConfigState';
import React from 'react';
import { MoversTopicConfig } from 'widgets/myPortfolioCapsules/topics/movers/moversTopicConfig';
import { CheckboxInput } from '@instinet-analytics/semantic-ui-components';
import './MoversTopicToolbar.scss';

export function MoversTopicToolbar() {
    const { config, dispatchConfigChanged } =
        useMyPortfolioCapsulesConfigSlice();

    const { includeNegative, includePositive } =
        config as unknown as MoversTopicConfig;

    const onPositiveClicked = () => {
        const delta: Partial<
            MyPortfolioCapsulesWidgetConfigState & MoversTopicConfig
        > = { includePositive: !includePositive };
        dispatchConfigChanged(delta);
    };
    const onNegativeClicked = () => {
        const delta: Partial<
            MyPortfolioCapsulesWidgetConfigState & MoversTopicConfig
        > = { includeNegative: !includeNegative };
        dispatchConfigChanged(delta);
    };

    return (
        <div className="MoversTopicToolbar ui">
            <div className="labels">Include:</div>
            <CheckboxInput
                className="pos-checkbox"
                label={'Up'}
                checked={includePositive}
                tooltip={'Include Positive Movements'}
                onToggle={onPositiveClicked}
            />
            <CheckboxInput
                className="neg-checkbox"
                label={'Down'}
                checked={includeNegative}
                tooltip={'Include Negative Movements'}
                onToggle={onNegativeClicked}
            />
        </div>
    );
}
